import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var Relationships = /*#__PURE__*/function () {
  function Relationships(context) {
    _classCallCheck(this, Relationships);

    this.context = context;
  }

  _createClass(Relationships, [{
    key: "getRelationships",
    value: function getRelationships(params) {
      return this.context.http.get('/msvc/v1/relationships/items', params, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
  }, {
    key: "getRelationshipsSearch",
    value: function getRelationshipsSearch(entityType, type, params) {
      return this.context.http.get("/msvc/v1/relationships/resolution/autocomplete/".concat(entityType, "/").concat(type), params);
    }
  }, {
    key: "getRelationshipsSearchByText",
    value: function getRelationshipsSearchByText(entityType, params) {
      return this.context.http.get("/msvc/v1/relationships/resolution/autocomplete/".concat(entityType), params);
    }
  }, {
    key: "setBulkRelationships",
    value: function setBulkRelationships(sourceEntityType, sourceEntityId, type, body) {
      return this.context.http.post("/msvc/v1/relationships/item/".concat(sourceEntityType, "/").concat(sourceEntityId, "/").concat(type), body);
    }
  }, {
    key: "getRelationshipsDetail",
    value: function getRelationshipsDetail(params) {
      return this.context.http.get('/msvc/v1/relationships/details', params, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
  }]);

  return Relationships;
}();

export default Relationships;